const doc = [({"SVP":"SVP", "SP":"SP", "FDP":"FDP", "CVP":"CVP", "GPS":"GPS", "BDP":"BDP", "GLP":"GLP"})];
module.exports = doc.length <= 1 ? doc[0] : doc;